import {
  LINK_ID_ON_CHANGE,
  LINK_RECORD_TO_ORDER_SUCCESS,
  LINK_RECORD_TO_ORDER_FAILED,
  GET_WAREHOUSE_RECORD_BY_ID_SUCCESS,
  GET_WAREHOUSE_RECORD_BY_ID_FAILED,
  DELETE_WAREHOUSE_RECORD_SUCCESS,
  DELETE_WAREHOUSE_RECORD_ERROR,
} from '../constants'

type State = {
  linkId: string,
  linkedPolicyId: string,
  error: string,
  warehouseRecord: {
    taobaoOrderId: string,
    warehouseLocation: string,
    isDamaged: boolean,
    deliveryTrackingNumber: string,
    notes: string,
    images: Array<string>,
  }
}

type Action = {
  type: string,
  payload: any,
}

const initialState = {
  linkId: '',
  error: '',
  linkedPolicyId: '',
  warehouseRecord: {
    taobaoOrderId: '',
    warehouseLocation: '',
    isDamaged: false,
    deliveryTrackingNumber: '',
    notes: '',
    images: [],
  },
}

function warehouseRecord(state: State = initialState, action: Action) {
  switch (action.type) {
    case LINK_ID_ON_CHANGE:
      return {
        ...state,
        linkId: action.payload
      }
    case LINK_RECORD_TO_ORDER_SUCCESS:
      return {
        ...state,
        linkedPolicyId: action.payload.policyId,
        warehouseRecord: action.payload,
        linkId: ''
      }
    case LINK_RECORD_TO_ORDER_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case GET_WAREHOUSE_RECORD_BY_ID_SUCCESS:
      return {
        ...state,
        warehouseRecord: action.payload
      }
    case GET_WAREHOUSE_RECORD_BY_ID_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case DELETE_WAREHOUSE_RECORD_SUCCESS:
      return {
        ...state,
        deleteResult: action.payload
      }
    case DELETE_WAREHOUSE_RECORD_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default warehouseRecord



// WEBPACK FOOTER //
// ./src/modules/warehouseRecord.js